var x = function(y) {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var y = function(x) { return function() { return x; }; }
var __WEBPACK_NAMESPACE_OBJECT__ = x({ ["opId"]: function() { return __WEBPACK_EXTERNAL_MODULE_swagger_client_es_helpers_4d7bea47__.opId; } });